import React from "react";
import { useSelector } from "react-redux";
import Success from "../../../components/Toaster/Success";
import GradientButton from "../../Buttons/GradientButton/GradientButton";
import NftInteractionModal from "../NftInteractionModal/NftInteractionModal";
import StyledMdText from "../../../common/components/styledMdText/StyledMdText";
import StyledH4Heading from "../../../common/components/styledH4Heading/StyledH4Heading";
import StyledH6Heading from "../../../common/components/styledH6Heading/StyledH6Heading";
const InsufficientFundsModal = ({ closeModal, nft }) => {
  const { walletAddress, walletBalance } = useSelector((state) => state.user);
  const handleCopy = () => {
    navigator.clipboard.writeText(walletAddress).then(() => {
      Success({ message: "Address copied to clipboard" });
    });
  };

  return (
    <NftInteractionModal
      handleClose={closeModal}
      width={"w-[95%] sm:w-4/5 md:w-4/6 lg:w-1/2 xl:w-1/3"}
      content={
        <div className="w-full flex flex-col gap-5 p-5 sm:p-10">
          <div className="space-y-2">
            <StyledH4Heading fontColor={"mb-4"}>
              Add Funds To Purchase
            </StyledH4Heading>
            <StyledH6Heading>
              You need {nft?.price ? Number(nft?.price).toFixed(3) : Number(nft).toFixed(3)} eth +{" "}
              <span className="textGradient">gas fees</span>
            </StyledH6Heading>
            <StyledMdText>
              Transfer funds to your wallet or add funds with a card. It can
              take up to a minute for your balance to update.
            </StyledMdText>
          </div>
          <div className="space-y-1">
            <div className="flex justify-between gap-5">
              <StyledH6Heading>Your ETH wallet:</StyledH6Heading>
              <StyledH6Heading>
                Balance: {Number(walletBalance).toFixed(3)} ETH
              </StyledH6Heading>
            </div>
            <div className="w-full flex items-center relative">
              <div className="w-full h-[44px] flex items-center border border-bright-yellow rounded-md text-md py-2 px-4 flex-grow bg-transparent">
                <StyledMdText fontColor={"truncate pr-52"}>
                  {walletAddress}
                </StyledMdText>
              </div>
              <button onClick={handleCopy} className="absolute right-3">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 21 24"
                  fill="none"
                >
                  <path
                    d="M4 18.5V3.5C4 2.11929 5.11929 1 6.5 1H15.305C15.9486 1 16.5673 1.24816 17.0325 1.69282L19.2275 3.79095C19.7209 4.26261 20 4.91553 20 5.59813V18.5C20 19.8807 18.8807 21 17.5 21H6.5C5.11929 21 4 19.8807 4 18.5Z"
                    stroke="#FFD700"
                  />
                  <path
                    d="M0 21.5V6.5C0 5.11929 1.11929 4 2.5 4H11.305C11.9486 4 12.5673 4.24816 13.0325 4.69282L15.2275 6.79095C15.7209 7.26261 16 7.91553 16 8.59813V21.5C16 22.8807 14.8807 24 13.5 24H2.5C1.11929 24 0 22.8807 0 21.5Z"
                    fill="#FFD700"
                  />
                </svg>
              </button>
            </div>
            <div>
              <GradientButton
                fontColor={"w-full mt-4"}
                children={"Continue"}
                disabled={
                  walletBalance > nft.price | true
                }
              />
            </div>
          </div>
        </div>
      }
    />
  );
};

export default InsufficientFundsModal;
